import React, { useContext, useState } from 'react'
import '../../styles/successModal.scss'
import { CalendarContext } from '../../context/CalendarContext';

const SuccessModal = ({ refNumber, seller, appointmentType, date, hour }) => {
  const [isCopied, setIsCopied] = useState(false);
  const { setIsModalOpen } = useContext(CalendarContext);

  const handleCopyClick = async () => {
    try {
      await navigator.clipboard.writeText(refNumber);
      setIsCopied(true); // Indica que el número ha sido copiado
      setTimeout(() => setIsCopied(false), 4000);
    } catch (err) {
      // Manejar el error (por ejemplo, si el acceso al portapapeles no está permitido)
      console.error('Failed to copy Ref Number:', err);
    }
  };

  return (
    <div className="success-modal-content">
      <div className='result-icon'>
        <i className="fas fa-check"></i>
      </div>
      <h2>Agenda Exitosa!</h2>
      <p>Tu cita ha sido agendada con éxito</p>
      <div className="success-details">
        <div className="ref-number">
          <div className='ref-number-title'>
            <span className='ref-number-text'>Ref Number</span>
            <span className='copy-ref-number' onClick={handleCopyClick}>{isCopied ? <><i className="fas fa-check"></i>Copiado</> : <><i className="fas fa-clipboard"></i>Copiar</>}</span>
          </div>
          <strong>{refNumber}</strong>
        </div>
        <div className='appointment-card-group' >
          <div className="seller appointment-card">
            <span>Seller</span>
            <strong>{seller}</strong>
          </div>
          <div className="appointment-type appointment-card">
            <span>Tipo de cita</span>
            <strong>{appointmentType}</strong>
          </div>
        </div>
        <div className="appointment-date appointment-card">
          <span>Fecha de cita</span>
          <strong>{date.toString()}, {hour}</strong>
        </div>
      </div>
      <button onClick={() => setIsModalOpen(false)}>Cerrar</button>
    </div>
  );
};

export default SuccessModal;